/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Crawling_UrlInputs */



/**
* | output |
* | --- |
* | "Reading webpage" |
*
* @param {Chat_Tool_Crawling_UrlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_crawling_url = /** @type {((inputs?: Chat_Tool_Crawling_UrlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Crawling_UrlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lese Webseite")
	return /** @type {LocalizedString} */ ("Reading webpage")
});